import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { PerfilCandidato } from 'src/app/interfaces/perfil';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { ProfileComponent } from '../profile.component';

@Component({
  selector: 'app-network-social-candidate',
  templateUrl: './network-social-candidate.component.html',
  styleUrls: ['./network-social-candidate.component.scss']
})
export class NetworkSocialCandidateComponent implements OnInit {

  usuario: JwtResponse;
  perfilCandidato: PerfilCandidato;
  formRS: FormGroup

  constructor(private ususarioService: UsuarioService, private modalService: NgbModal, private formBuilder: FormBuilder,
    private profileComponent: ProfileComponent) { 
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.perfilCandidato = {} as PerfilCandidato;
  }

  ngOnInit() {
    this.formRS = this.formBuilder.group({
      linkedinUrl: [null],
      facebookUrl: [null],
      twitterUrl: [null]
    });
  }

  public cargarRedesSocialesCandidato(perfil: PerfilCandidato): void {
    this.perfilCandidato = perfil;
  }

  actualizarRedesSociales(): void {
    const candidato = {
      id: this.usuario.user.idUsuario,
      linkedinUrl: this.formRS.get('linkedinUrl').value || this.perfilCandidato.linkedin,
      facebookUrl: this.formRS.get('facebookUrl').value || this.perfilCandidato.facebook,
      twitterUrl: this.formRS.get('twitterUrl').value || this.perfilCandidato.twitter
    }

    this.ususarioService.actualizarRedesSocialesCandidato(JSON.stringify(candidato)).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.profileComponent.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha actulizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizar las redes sociales del candidato: ', result.messageError);
      }
    });
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }
}
